<template>
  <div class="nch--blog-home">
    <div class="nch--blog-container">
      <div class="nch--blog-content">
        <Posts :style="{ order: mobile ? 2 : 1 }"/>
        <Aside :style="{ order: mobile ? 1 : 2 }"/>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '../../common/Card';
import Breadcrumb from '../../common/Breadcrumb';
import Aside from '../../Aside';
import Posts from './Posts';
import theme from '../../../mixins/theme';
import responsive from '../../../mixins/responsive';

export default {
  name: 'Home',
  components: {
    Card,
    Breadcrumb,
    Aside,
    Posts,
  },
  mixins: [
    theme,
    responsive,
  ],
  props: {
    user: {
      type: Object,
      description: 'Nochalks user object',
    },
    settings: {
      type: Object,
      default: () => ({
        title: 'Blog',
      }),
    },
  },
  data() {
    return {
      breadcrumb: [
        { name: this.settings.title, href: '/' },
      ],
    };
  },
  computed: {
    mobile() {
      return this.xs || this.sm;
    },
  },
};
</script>

<style scoped>
.nch--blog-home {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.nch--blog-container {
  width: var(--blog-container-width);
}
.nch--blog-content{
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas: "content aside";
}
.nch--blog-content article {
  margin: 2rem 0;
  letter-spacing: 0.003em;
  word-spacing: 0.003em;
  line-height: 1.4;
  text-align: justify;
  font-size: 1.2rem;
}
@media (max-width: 900px) {
  .nch--blog-content {
    display: flex;
    flex-direction: column;
  }
}
</style>
<style>
.nch--blog-home * {
  font-family: var(--blog-font-family);
}
.nch--blog-home article img {
  max-width: 100%;
}
</style>
